import React, { useState, useEffect } from 'react';
import { Edit3, Save, X, Loader2, RefreshCw, Plus, AlertCircle, Upload, Check } from 'lucide-react';
import './PushNotification.css';

export default function PushNotification() {
    const [notifications, setNotifications] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [imageUploading, setImageUploading] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [selectedNotif, setSelectedNotif] = useState(null);
    const [errors, setErrors] = useState({});
    const [msgModel, setMsgModel] = useState({
        open: false,
        msg: "",
        isError: false
    });
    const [newNotif, setNewNotif] = useState({
        userID: "",
        title: "",
        image: "",
        desc: "",
        enabled: "Y",
        closable: "Y",
        content: "",
        priority: "1"
    });

    useEffect(() => {
        fetchNotifications();
    }, []);




    const fetchNotifications = async () => {
        setPageLoading(true);
        try {
            const response = await fetch("http://api.bumppypay.com/api/Apitranxt/user/get_user_notifications", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ userID: "ADMIN" })
            });

            const result = await response.json();
            console.log("Fetch Notification:", result);

            if (result.status === "0" && Array.isArray(result.data)) {
                setNotifications(result.data);
            } else {
                setNotifications([]);
            }

        }
        catch (error) {
            console.error("Fetch Error:", error);
            setNotifications([]);
        }
        finally {
            setPageLoading(false);
        }
    };


    const handleImageUpload = async (file) => {

        if (!file.type.startsWith('image/')) {
            setErrors(prev => ({ ...prev, image: "Please upload an image file only." }));
            return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = (event) => {
            const img = new Image()
            img.src = event.target.result;

            img.onload = async () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);  
                const base64Data = canvas.toDataURL('image/jpeg', 0.9).split(',')[1];
                const timestamp = Date.now();
                const fileName = `img_${timestamp}`;
                const fileNameWithExt = `${fileName}.jpeg`;

                const payload = {
                    imagename: fileName,
                    imagebytedata: base64Data
                };



                setImageUploading(true);
                try {
                    const response = await fetch(`https://apiservices.bumppypay.com/api/Payment/imageUpload`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(payload)
                    });

                    const result = await response.json();


                    if (result.status === "0" || result.status === "true") {
                        const imageUrl = `https://api.bumppypay.com/slipupload/${fileNameWithExt}`;
                        setNewNotif(prev => ({ ...prev, image: imageUrl }));
                        setErrors(prev => ({ ...prev, image: null }));
                    } else {
                        setErrors(prev => ({ ...prev, image: result.msg || "Upload failed" }));
                    }

                } catch (error) {
                    setErrors(prev => ({ ...prev, image: "Network Error: Could not upload image" }));
                } finally {
                    setImageUploading(false);
                }
            };
        }
    }


    const handleEditClick = (notif) => {
        setSelectedNotif({ ...notif });
        setIsEditModalOpen(true);
    };

    const handleUpdateStatus = async () => {
        if (!selectedNotif) return;
        setSaving(true);

        try {
            const payload = {
                userID: selectedNotif.fk_user_id || "",
                adminID: "9",
                notificationID: selectedNotif.pk_notification_id.toString(),
                status: selectedNotif.enabled
            };

            const response = await fetch("http://api.bumppypay.com/api/Apitranxt/user/update_user_notifications", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            const result = await response.json();


            if (result.status === "0" || result.status === "true") {
                setMsgModel({ open: true, msg: "Status Update Successfully!", isError: false });
                setIsEditModalOpen(false);
                fetchNotifications();
            } else {
                setMsgModel({ open: true, msg: result.message || "Update Failed", isError: true });
            }
        } catch (error) {
            console.error("Update Error:", error);
            setMsgModel({ open: true, msg: "Failed to connect to the server.", isError: true })
        } finally {
            setSaving(false);
        }
    };


    const validateNewNotif = () => {
        let errors = {};
        if (!newNotif.title.trim())
            errors.title = "Title is required!";
        if (!newNotif.desc.trim()) errors.desc = "Description is required!";
        if (!newNotif.content.trim()) errors.content = "Content is required!";
        if (!newNotif.image) errors.image = "Image required";

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };


    const handleAddNotification = async () => {
        if (!validateNewNotif()) return;
        setSaving(true);
        try {
            const response = await fetch("http://api.bumppypay.com/api/Apitranxt/user/add_user_notifications", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(newNotif)
            });


            const result = await response.json();
            console.log("Add notification", result)

            if (result.status === "0" || result.status === "true") {
                setIsAddModalOpen(false);
                setMsgModel({ open: true, msg: "Notification Created Successfully!", isError: false });
                setNewNotif({
                    userID: "",
                    title: "",
                    image: "",
                    desc: "",
                    enabled: "Y",
                    closable: "Y",
                    content: "",
                    priority: "1"
                });
                fetchNotifications();
            }
            else {
                setMsgModel({ open: true, msg: result.msg || "Failed to add", isError: true });
            }
        }
        catch (error) {
            setErrors({ api: "Server error: " + error.message });
        }
        finally {
            setSaving(false);
        }
    };


    const handlePriorityChange = (id, newPriority) => {
        setNotifications(prev => prev.map(item =>
            item.pk_notification_id === id ? { ...item, priority: newPriority } : item
        ));
    };

    const handleSortOnBlur = () => {
        setNotifications(prev => [...prev].sort((a, b) =>
            parseInt(a.priority || 0) - parseInt(b.priority || 0)
        ));
    };

    return (
        <div className="notif-container">
            <div className="nm-table-wrapper">
                <div className="nm-header">
                    <h2 style={{ margin: 0, fontSize: '1.25rem', color:"#0f172a" }}>Notification Management</h2>
                    <div className='nm-action-group'>
                        <button className="nm-btn-primary" onClick={() => setIsAddModalOpen(true)}>
                            <Plus size={16} /> Add Notification
                        </button>
                        <button onClick={fetchNotifications} className="nm-btn-primary" disabled={pageLoading}>
                            <RefreshCw size={16} className={pageLoading ? "nm-spin" : ""} />
                            {pageLoading ? "Loading..." : "Refresh"}
                        </button>
                    </div>
                </div>

               
                <div className="nm-table">
                    <div className="nm-thead">
                        <div className="nm-tr">
                            <div className="nm-th w-5">ID</div>
                            <div className="nm-th w-10">User ID</div>
                            <div className="nm-th w-15">Title</div>
                            <div className="nm-th w-10">Image</div>
                            <div className="nm-th w-20">Description</div>
                            <div className="nm-th w-15">Content</div>
                            <div className="nm-th w-8">Priority</div>
                            <div className="nm-th w-8">Enable</div>
                            <div className="nm-th w-8">Closable</div>
                            <div className="nm-th w-9">Action</div>
                        </div>
                    </div>                    
                    <div className="nm-tbody">
                        {pageLoading ? (
                            <div className="nm-row-loader">
                                <Loader2 className="nm-spin" /> Loading data...
                            </div>
                        ) : notifications.length > 0 ? (
                            notifications.map((item) => (
                                <div className="nm-tr" key={item.pk_notification_id}>
                                    <div className="nm-td w-5">{item.pk_notification_id}</div>
                                    <div className="nm-td w-10">{item.fk_user_id}</div>
                                    <div className="nm-td w-15 nm-font-bold">
                                        {item.notification_title || <span className="nm-text-red">--</span>}
                                    </div>
                                    <div className="nm-td w-10">
                                        {item.notification_image ? (
                                            <img
                                                src={item.notification_image}
                                                alt="Notif"
                                                className="nm-img-preview"
                                            />
                                        ) : (
                                            <span className="nm-text-red">--</span>
                                        )}
                                    </div>
                                    <div className="nm-td w-20">
                                        <div className="nm-content-scroll">{item.notification_description || <span className="nm-text-red">--</span>}</div>
                                    </div>
                                    <div className="nm-td w-15">
                                        <div className="nm-content-scroll">{item.content || <span className="nm-text-red">--</span>}</div>
                                    </div>
                                    <div className="nm-td w-8">
                                        <input
                                            type="number"
                                            value={item.priority === "" ? "" : (item.priority || 0)}
                                            className="nm-priority-input"
                                            onChange={(e) => handlePriorityChange(item.pk_notification_id, e.target.value)}
                                            onBlur={handleSortOnBlur}
                                        />
                                    </div>
                                    <div className="nm-td w-8">
                                        <div className={`nm-badge nm-status-${item.enabled || 'NULL'}`}>
                                            {item.enabled || '-'}
                                        </div>
                                    </div>
                                    <div className="nm-td w-8">
                                        <span className={`nm-alert-tag ${item.closable === 'N' ? 'nm-sticky' : 'nm-dismissible'}`}>
                                            {item.closable || 'Y'}
                                        </span>
                                    </div>
                                    <div className="nm-td w-9">
                                        <button className="nm-edit-btn" onClick={(e) => { e.stopPropagation(); handleEditClick(item) }}>
                                            <Edit3 size={14} /> Edit
                                        </button>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="nm-no-data">No notifications found.</div>
                        )}
                    </div>
                </div>
            </div>

            {isEditModalOpen && (
                <div className="nm-edit-overlay">
                    <div className="nm-edit-card">
                        <div className="nm-edit-header">
                            <h3>Update Status #{selectedNotif?.pk_notification_id}</h3>
                            <X className="nm-edit-close" onClick={() => setIsEditModalOpen(false)} />
                        </div>
                        <div className="nm-edit-body">
                            <div className="nm-edit-info-box">
                                <p><strong>Title:</strong> {selectedNotif?.notification_title}</p>
                            </div>
                            <div className="nm-edit-field">
                                <label className="nm-edit-label">Status</label>
                                <select
                                    className="nm-edit-select"
                                    value={selectedNotif?.enabled}
                                    onChange={(e) => setSelectedNotif({ ...selectedNotif, enabled: e.target.value })}
                                >
                                    <option value="Y">Y (Active)</option>
                                    <option value="N">N (Inactive)</option>
                                    <option value="M">M (Maintenance)</option>
                                    <option value="V">V (Verification)</option>
                                </select>
                            </div>
                        </div>
                        <div className="nm-edit-footer">
                            <button className="nm-edit-btn-cancel" onClick={() => setIsEditModalOpen(false)}>Cancel</button>
                            <button className="nm-edit-btn-save" onClick={handleUpdateStatus} disabled={saving}>
                                {saving ? <Loader2 className="nm-spin" size={18} /> : <Save size={18} />}
                                {saving ? "Updating..." : "Save Changes"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {isAddModalOpen && (
                <div className="nm-mod-overlay">
                    <div className="nm-mod-container">
                        <div className="nm-mod-header">
                            <h3>New Notification</h3>
                            <X className="nm-mod-close-icon" onClick={() => setIsAddModalOpen(false)} />
                        </div>

                        <div className="nm-mod-body">
                            {errors.api && (
                                <div className="nm-mod-error-banner">
                                    <AlertCircle size={16} /> {errors.api}
                                </div>
                            )}

                            <div className="nm-mod-grid">
                                <div className="nm-mod-field">
                                    <label className="nm-mod-label">User ID </label>
                                    <input
                                        type="text"
                                        className="nm-mod-input"
                                        value={newNotif.userID}
                                        placeholder="Enter User ID"
                                        onChange={(e) => setNewNotif({ ...newNotif, userID: e.target.value })}
                                    />
                                </div>
                                <div className="nm-mod-field">
                                    <label className="nm-mod-label">Title <span className="nm-mod-star">*</span></label>
                                    <input
                                        type="text"
                                        className="nm-mod-input"
                                        value={newNotif.title}
                                        placeholder="Notification Title"
                                        onChange={(e) => setNewNotif({ ...newNotif, title: e.target.value })}
                                    />
                                    {errors.title && <span className="nm-mod-error-text">{errors.title}</span>}
                                </div>
                            </div>

                            <div className="nm-mod-grid nm-mod-grid-single">
                                <div className="nm-mod-field">
                                    <label className="nm-mod-label">Priority <span className="nm-mod-star">*</span></label>
                                    <input
                                        type="number"
                                        className="nm-mod-input"
                                        value={newNotif.priority}
                                        placeholder="1"
                                        onChange={(e) => setNewNotif({ ...newNotif, priority: e.target.value })}
                                    />
                                </div>
                            </div>

                            <div className="nm-mod-field">
                                <label className="nm-mod-label">Description <span className="nm-mod-star">*</span></label>
                                <input
                                    type="text"
                                    className="nm-mod-input"
                                    value={newNotif.desc}
                                    placeholder="Short description..."
                                    onChange={(e) => setNewNotif({ ...newNotif, desc: e.target.value })}
                                />
                                {errors.desc && <span className="nm-mod-error-text">{errors.desc}</span>}
                            </div>

                            <div className="nm-mod-field">
                                <label className="nm-mod-label">Content <span className="nm-mod-star">*</span></label>
                                <textarea
                                    rows="3"
                                    className="nm-mod-textarea"
                                    value={newNotif.content}
                                    placeholder="Enter detailed content here..."
                                    onChange={(e) => setNewNotif({ ...newNotif, content: e.target.value })}
                                />
                                {errors.content && <span className="nm-mod-error-text">{errors.content}</span>}
                            </div>

                            <div className="nm-mod-grid">
                                <div className="nm-mod-field">
                                    <label className="nm-mod-label">Enabled (Y/N) <span className="nm-mod-star">*</span></label>
                                    <select className="nm-mod-select" onChange={(e) => setNewNotif({ ...newNotif, enabled: e.target.value })}>
                                        <option value="Y">Yes</option>
                                        <option value="N">No</option>
                                    </select>
                                </div>
                                <div className="nm-mod-field">
                                    <label className="nm-mod-label">Closable (Y/N) <span className="nm-mod-star">*</span></label>
                                    <select className="nm-mod-select" onChange={(e) => setNewNotif({ ...newNotif, closable: e.target.value })}>
                                        <option value="Y">Yes</option>
                                        <option value="N">No</option>
                                    </select>
                                </div>
                            </div>

                            <div className="nm-mod-field">
                                <label className="nm-mod-label">Image <span className="nm-mod-star">*</span></label>
                                <div className="nm-mod-upload-box">
                                    <input
                                        type="file"
                                        id="nm-mod-file-input"
                                        className="nm-mod-file-hidden"
                                        accept="image/*"
                                        disabled={saving}
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) handleImageUpload(file);
                                        }}
                                    />
                                    <label htmlFor="nm-mod-file-input" className="nm-mod-upload-label">
                                        {imageUploading && !newNotif.image ? <Loader2 className="nm-mod-spin" size={18} /> : <Upload size={18} />}
                                        {newNotif.image ? " Image Uploaded " : " Choose Image"}
                                    </label>

                                    {errors.image && <span className="nm-mod-error-text">{errors.image}</span>}

                                    {newNotif.image && (
                                        <div className="nm-mod-img-preview-wrap">
                                            <img src={newNotif.image} alt="Preview" />
                                            <button
                                                type="button"
                                                className="nm-mod-remove-img"
                                                onClick={() => setNewNotif({ ...newNotif, image: "" })}
                                            >
                                                <X size={16} />
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="nm-mod-footer">
                           
                            <button className="nm-mod-btn-cancel" onClick={() => setIsAddModalOpen(false)}>Cancel</button>
                            <button className="nm-mod-btn-save" onClick={handleAddNotification} disabled={saving}>
                                {saving ? "Saving..." : "Create Notification"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {msgModel.open && (
                <div className="modal-overlay">
                    <div className="edit-modal feedback-modal" style={{ maxWidth: '350px' }}>
                        <div className="modal-body" style={{ textAlign: 'center', padding: '10px' }}>


                            <div className={`feedback-icon-container ${msgModel.isError ? 'icon-error' : 'icon-success'}`}>
                                {msgModel.isError ? <AlertCircle size={32} /> : <Check size={32} />}
                            </div>


                            <h3>{msgModel.isError ? "Error" : "Success"}</h3>
                            <p>{msgModel.msg}</p>


                            <button
                                className="feedback-close-btn"
                                style={{ marginTop: '24px', width: '100%' }}
                                onClick={() => setMsgModel({ ...msgModel, open: false })}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}